if (!customElements.get('shipping-eligibility')) {
  customElements.define('shipping-eligibility', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info') || this.closest('section');
      this.onChange = () => {
        this.hide();
        clearTimeout(this.timer);
        this.controller?.abort();
        this.timer = setTimeout(() => this.check(), 300);
      };
      this.onVisibility = () => { if (!document.hidden) this.onChange(); };
      this.scope?.addEventListener('change', this.onChange);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.check();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.scope?.removeEventListener('change', this.onChange);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    hide() {
      const badge = this.querySelector('a');
      if (badge) badge.hidden = true;
    }

    async check() {
      this.hide();
      clearTimeout(this.timer);
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      try {
        if (document.hidden || !this.isConnected) return;
        const options = this.querySelector('template')?.content.querySelectorAll('option');
        const country = [...(options || [])].find(o => o.textContent.trim() === this.dataset.countryName || o.value === this.dataset.countryName);
        if (!country) throw new Error('country_reference_missing');
        const provinces = JSON.parse(country.dataset.provinces);
        const quantity = Number(this.scope?.querySelector('input[name="quantity"]')?.value || 1);
        const input = {variantId:this.dataset.variant,country:this.dataset.country,currency:this.dataset.currency,
          quantity,unitPrice:Number(this.dataset.price),provinceNames:provinces.map(p => p[0])};
        const timeout = setTimeout(() => controller.abort(), 20000);
        let response;
        try {
          response = await fetch('https://oudhalo-shipping-sync.tonywei49.workers.dev/eligibility', {
            method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(input),signal:controller.signal
          });
        } finally { clearTimeout(timeout); }
        const result = await response.json();
        if (!this.isConnected || this.controller !== controller || controller.signal.aborted) return;
        if (!response.ok || result.status === 'unknown') throw new Error(result.reason || 'shipping_check_failed');
        const remaining = result.expiresAt - Date.now();
        if (remaining <= 0 || result.variantId !== input.variantId || result.quantity !== quantity || result.currency !== input.currency || result.country !== input.country) throw new Error('stale_shipping_result');
        this.dataset.status = result.status;
        delete this.dataset.error;
        this.querySelector('a').hidden = result.status !== 'free';
        this.timer = setTimeout(() => { this.hide(); this.check(); }, Math.min(remaining,60000));
      } catch (error) {
        if (this.controller !== controller || !this.isConnected) return;
        this.hide();
        this.dataset.status = 'unknown';
        this.dataset.error = error.message;
        console.warn('Shipping badge unavailable:', error.message);
        if (!document.hidden) this.timer = setTimeout(() => this.check(),60000);
      }
    }
  });
}
